import { connect } from "react-redux";

import Email from "./Email";

export default connect(state => ({
	email: state.settings.email,
	auth: state.user
}))(Email);
